import { ResortLink } from "../resort-button";
import { Eyebrow, Reveal } from "../reveal";

export function ExtendedStayWaitlist() {
  return (
    <section
      id="waitlist"
      aria-labelledby="waitlist-heading"
      className="bg-secondary/45 py-14 md:py-16"
    >
      <div className="shell">
        <Reveal>
          <div className="border border-border bg-background p-8 md:p-12 lg:p-14">
            <Eyebrow>Important to Know</Eyebrow>
            <h2 id="waitlist-heading" className="display-md mt-5 max-w-[22ch]">
              About Our Extended-Stay Waitlist
            </h2>
            <div className="mt-8 max-w-3xl space-y-5 text-base leading-relaxed text-muted-foreground">
              <p>
                Because extended-stay guests leave at different times, future availability can
                sometimes be difficult to predict. Auburn RV Resort may place prospective monthly
                guests on a waitlist when no site is currently available.
              </p>
              <p className="font-medium text-foreground">
                Being added to the waitlist does not guarantee a future site.
              </p>
              <p>
                We recommend keeping alternative accommodations in mind until Auburn RV Resort
                confirms an available site and your reservation process is complete.
              </p>
            </div>
            <ResortLink variant="solid" href="/reservations/" className="mt-10 w-full sm:w-auto">
              Ask About Extended Stay
            </ResortLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
